var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{class:{ 'fill-height': _vm.$vuetify.breakpoint.smAndUp }},[_c('v-row',[_c('v-col',{staticClass:"d-flex justify-center align-center",attrs:{"cols":"12","sm":"6","md":"4","lg":"3"}},[_c('p',[_vm._v("404")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }